/* eslint-disable */
import {
	useState, useEffect, useMemo, useCallback
} from 'react';
import {
	meals,
	parentTabs,
	tabs,
	tableTabsIssuedSummary,
	tableTabsProducedSummary,
	tableTabsDispatchedSummary,
	tableTabsOverView,
	tableTabsPackagedSummary,
	tableTabsWastageSummary,
	nagaIssuedSummaryTabs,
	nagaProducedSummaryTabs,
	tableTabsDispatchedSummaryNaga,
} from '../constants';
import { useSelector } from 'react-redux';

// Map of table tab names to their arrays
const tableTabsMap = {
	tableTabsIssuedSummary,
	tableTabsProducedSummary,
	tableTabsDispatchedSummary,
	tableTabsOverView,
	tableTabsPackagedSummary,
	tableTabsWastageSummary,
	nagaIssuedSummaryTabs,
	nagaProducedSummaryTabs,
	tableTabsDispatchedSummaryNaga,
};

export const useTableState = (rawData, setSearch, isNagaCustomer = false, isDanaChogaCustomer = false, parentTabList) => {
	const [parentTab, setParentTab] = useState(parentTabList[0]);
	const [active, setActive] = useState(null);
	const [selectedTab, setSelectedTab] = useState(tabs[0]?.id);
	const [selectSubTab, setSelectSubTab] = useState(tabs.find(e => e.id === selectedTab)?.subTabs?.[0]?.id)
	const [perUnit, setPerUnit] = useState(false)
	const [tableTab, setTableTab] = useState('');
	const [mealTabsList, setMealTabsList] = useState([]);
	const shiftList = useSelector((state) => state?.analytics?.SHIFT_LIST);
	const [parentTabVersion, setParentTabVersion] = useState(0);

	const getTableTabsForParent = useCallback((tab) => {
		if (!tab) return [];
		if (tab.tableTabsNaga) {
			return tableTabsMap[tab.tableTabsNaga] || [];
		}
		if (tab.tableTabs) {
			return tableTabsMap[tab.tableTabs] || [];
		}

		return [];
	}, [isNagaCustomer, isDanaChogaCustomer]);

	useEffect(() => {
		setMealTabsList([{ id: -999, shiftName: 'All' }, ...shiftList]);
	}, [shiftList]);

	useEffect(() => {
		if (mealTabsList?.length > 0) {
			setActive(mealTabsList[0]);
		}
	}, [mealTabsList]);

	useEffect(() => {
		const tabList = getTableTabsForParent(parentTab);
		if (tabList?.length > 0) {
			setTableTab(tabList[0]?.value);
			setParentTabVersion((prev) => prev + 1);
		}
	}, [parentTab, getTableTabsForParent]);

	const data = useMemo(() => {
		if (!rawData?.length || !active) return {};
		const currentData = rawData.find((item) => item?.mealType === active?.value) || {};
		return currentData;
	}, [rawData, active]);

	const handleParentTab = useCallback((tab) => {
		setParentTab(tab);
	}, []);

	const handleMealTab = useCallback((tab) => {
		setActive(tab);
	}, []);

	const handleTableTab = useCallback((value) => {
		setSearch({});
		// if (value !== 'rawMaterials') {
		// 	setSelectedTab('weight');
		// }
		setTableTab(value);
		setParentTabVersion((prev) => prev + 1);
	}, []);

	const getTabInfo = useCallback(() => {
		const tabList = getTableTabsForParent(parentTab);

		return {
			tabList: tabList,
			activeTabColor: 'bg-yellow-200',
			tabValue: tableTab,
			handleTabChange: handleTableTab,
		};
	}, [parentTab, tableTab, handleTableTab, getTableTabsForParent]);

	const getAvailableTabs = useCallback(() => {
		let currentTabs = tabs;
		if ((parentTab?.value === 'ISSUED' && tableTab === 'rawMaterials') ||
			(parentTab?.value === 'PRODUCED' && tableTab === 'products')) {
			currentTabs = tabs;
		} else {
			currentTabs = tabs.filter((tab) => tab.id !== 'percentage');
		}

		return currentTabs.map((tab) => {
			let disabled = false;
			let tooltip = '';

			if (tab.id === 'cost' && parentTab?.value === 'PRODUCED') {
				disabled = true;
				tooltip = 'Calculation logic required';
			}

			return {
				...tab,
				...(disabled && { disabled, tooltip }),
			};
		});
	}, [parentTab, tableTab]);

	return {
		parentTab,
		active,
		selectedTab,
		tableTab,
		mealTabsList,
		data,
		setSelectedTab,
		handleParentTab,
		handleMealTab,
		handleTableTab,
		getTabInfo,
		getAvailableTabs,
		parentTabVersion,
		selectSubTab,
		setSelectSubTab,
		perUnit,
		setPerUnit
	};
};
